import React from 'react'
import { Link } from 'react-router-dom'

import './style.css'

const noop = () => {}

const SkipForNow = ({ text, path, handleClick }) => (
  <div onClick={handleClick} className="skip-for-now-link">
    <Link to={`${path}`}>{text}</Link>
  </div>
)

SkipForNow.defaultProps = {
  text: 'Skip for now',
  handleClick: noop
}

export default SkipForNow